/**
 * Generated by Orval
 * Do not edit manually.
 */
import type { StoreLogMessageBody } from '../index.schemas.ts';

import { apiFetch } from '../../../utils/fetch.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Store a log message of a specific type.
 * @summary Submit message to log
 */
export const storeLogMessage = (
  type: string,
  storeLogMessageBody: StoreLogMessageBody,
  options?: SecondParameter<typeof apiFetch<void>>,
) => {
  return apiFetch<void>(
    {
      url: `/front-office/v1/logs/${type}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: storeLogMessageBody,
    },
    options,
  );
};
export type StoreLogMessageResult = NonNullable<Awaited<ReturnType<typeof storeLogMessage>>>;
